/* =========================================================
   ParcelPanel – Timeline Icon Overrides (Mobile + Desktop)
   Custom SVGs + Larger Icons
   ========================================================= */

(function () {

  const ICON_MAP = [
    {
      match: 'Mosaic Tailoring in Progress',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Mosaic_Cutting_In_progress.svg?v=1770300991'
    },
    {
      match: 'Mosaic Is Being Assembled',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Mosaic_Is_Being_Assembled.svg?v=1770300992'
    },
    {
      match: 'Order Ready',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Order_Ready.svg?v=1770300991'
    },
    {
      match: 'In Transit',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/In_Transit.svg?v=1770300991'
    },
    {
      match: 'Out for Delivery',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Out_for_Delivery.svg?v=1770300991'
    },
    {
      match: 'Delivered',
      icon: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Delivered.svg?v=1770300991'
    }
  ];

  function overrideTimelineIcons() {
    const items = document.querySelectorAll('.timeline-item');

    items.forEach(item => {
      const text = item.innerText || '';
      const badge = item.querySelector('.timeline-badge.timeline-item__badge');
      if (!badge) return;

      ICON_MAP.forEach(({ match, icon }) => {
        if (text.includes(match)) {
          badge.style.cssText = `
            background-image: url("${icon}") !important;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 100% !important;
          `;
        }
      });
    });
  }

  // Initial run
  overrideTimelineIcons();

  // ParcelPanel dynamically re-renders
  const observer = new MutationObserver(overrideTimelineIcons);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
